import {
  CARD,
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  TEXT,
  VIDEO,
  VideoDefinition,
  QUIZ_CHOICE
} from '../items';
import { Translator } from '../Translator';
import { PhoneHelper } from './itemHelpers/PhoneHelper';
import { ItemOfType } from './itemHelpers/types';
import { translate } from './translate';
import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';

export const SocialMedia4: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Phone':
        columns.items.push(
          PhoneHelper(
            item as ItemOfType<'Phone'>,
            sequence,
            sequence.personalization,
            true,
            false,
            true
          )
        );
        break;

      case 'Card':
        columns.items.push({
          type: CARD,
          id: '1',
          values: {
            clearStyles: 'lg',
            height: '100%',
            width: { _: '300px', lg: '100%' },
            padding: { _: '0px', lg: '17% 0px 0px 0px' }
          },
          items: [
            {
              id: 'video',
              type: VIDEO,
              values: {
                mediaUrl:
                  item.videos && item.videos.length
                    ? [{ src: item.videos[0].mediaUrl!, type: 'video/mp4' }]
                    : null,
                subtitlesUrl:
                  item.videos && item.videos.length
                    ? item.videos[0].subtitlesUrl
                    : null,
                autoPlay:
                  item.videos && item.videos.length
                    ? item.videos[0].autoPlay
                    : null,
                showProgress: true,
                showPlayButton: true,
                replay: true,
                videoContainerStyles: {
                  width: '300px',
                  height: '500px',
                  position: 'relative',
                  borderRadius: '20px'
                }
              },
              items: []
            } as VideoDefinition
          ]
        });
        break;
      case 'Text':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            }
          ]
        } as LayoutListDefinition);
        break;
      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle || 'QUIZ',
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            },
            {
              type: QUIZ_CHOICE,
              id: '1',
              values: {
                variant: item.items && item.items.length > 2 ? 'list' : '',
                title: item?.title?.includes('?')
                  ? item.title
                  : item?.body?.includes('?')
                  ? item.body
                  : '',
                length: item?.items?.length,
                multiSelect: item?.items?.filter(item => item.correct === true)
                  .length
              },
              items: AnswerButtonHelper(
                item.id,
                item.items,
                undefined,
                item.llamaSurvey,
                item.title || ''
              )
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
